import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerSW } from "@/utils/swRegister";
import { bootstrapConsentMode } from "@/services/consent";

// Install Google Consent Mode v2 defaults (deny) BEFORE any pixel can
// fire. Subsequent script injection via useTracking will see denied
// defaults and respect the visitor's eventual choice.
bootstrapConsentMode();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerSW();
